import * as React from 'react'

import moment from 'moment'
import type { Moment } from 'moment'

import { useScene } from '../context/SceneContext'
import { BottomTimeFlag } from './BottomTimeFlag'

export type CurrentDelegationTimeBlockProps = {
  begin: Moment
  end: Moment
  index: number
}

const color = '#2448BB'


const COMPACT_WIDTH = 92

const TimeLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div
    className="tw-grid tw-w-fit tw-place-items-center tw-rounded tw-px-1 tw-text-sm tw-font-medium tw-text-white"
    style={{ background: color, opacity: 0.95 }}
  >
    {children}
  </div>
)

export const CurrentDelegationTimeBlock: React.FC<CurrentDelegationTimeBlockProps> =
  React.memo((props: CurrentDelegationTimeBlockProps) => {
    const scene = useScene()
    const begin = moment(props.begin)
    const end = moment(props.end)

    if (!begin.isValid() || !end.isValid()) return null

    const dayStart = scene.startTime
    const dayEnd = dayStart.clone().add(scene.days, 'days')

    const showBegin = begin.isSameOrAfter(dayStart) && begin.isBefore(dayEnd)
    const showEnd = end.isAfter(dayStart) && end.isSameOrBefore(dayEnd)

    if (!showBegin && !showEnd) return null

    const beginX = scene.timeToX(begin)
    const endX = scene.timeToX(end)

    if (showBegin && showEnd && endX - beginX < COMPACT_WIDTH) {
      return (
        <BottomTimeFlag
          left={beginX}
          chartWidth={scene.width}
          inner="right"
          tickColor={color}
        >
          <TimeLabel>
            {`${begin.format('HH:mm')} - ${end.format('HH:mm')}`}
          </TimeLabel>
        </BottomTimeFlag>
      )
    }

    return (
      <>
        {showBegin && (
          <BottomTimeFlag
            left={beginX}
            chartWidth={scene.width}
            inner="right"
            tickColor={color}
          >
            <TimeLabel>{begin.format('HH:mm')}</TimeLabel>
          </BottomTimeFlag>
        )}
        {showEnd && (
          <BottomTimeFlag
            left={endX}
            chartWidth={scene.width}
            inner="left"
            tickColor={color}
          >
            <TimeLabel>{end.format('HH:mm')}</TimeLabel>
          </BottomTimeFlag>
        )}
      </>
    )
  })

CurrentDelegationTimeBlock.displayName = 'CurrentDelegationTimeBlock'
